var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{class:{'toggled': _vm.toggled},attrs:{"id":"sidebar-right"}},[_c('div',{staticClass:"sidebar-inner c-overflow"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }